import NavigateRoute from "./Routers/NavigateRoute";

function App() {
  return (
    <div>
      <NavigateRoute />
    </div>
  );
}

export default App;
